import { useEffect, useState } from "react";

// Components
import SupportItem from "components/atoms/SupportItem";
import InfoHeader from "components/atoms/InfoHeader";

// Constants
import { useGTM } from "hooks/useGTM";
import { getLocalStorageItem } from "utils/localStorage";
import { STORAGE_USER_COUNTRY } from "../../../constants/variables";
import { PHONE_GEO_LIST } from "../../../constants/phoneSupportGeo";

// Icons
import Email from "../../../assets/icons/info_email.svg?react";
import Phone from "../../../assets/icons/info_phone.svg?react";

// Hooks

// Utils

import "./styles.sass";

const SupportInfo = () => {
  const GTM = useGTM();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const [countryStatus, setCountryStatus] = useState(false);
  const currentCountry = getLocalStorageItem(STORAGE_USER_COUNTRY);

  useEffect(() => {
    if (PHONE_GEO_LIST.includes(currentCountry)) {
      setCountryStatus(true);
    }
  }, [currentCountry]);

  useEffect(() => {
    GTM.openSupportPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emailBlock = {
    id: 1,
    image: <Email />,
    title: "info.support.email.title",
    description: `info.support.email.description.${VITE_APP_PROJECT_NAME}`,
    notice: "",
  };
  const phoneBlock = {
    id: 2,
    image: <Phone />,
    title: "info.support.phone.title",
    description: "info.support.phone.description",
    notice: "info.support.phone.notice",
  };

  const isGlory = VITE_APP_PROJECT_NAME === "glory";
  return (
    <div className="SupportInfo">
      <InfoHeader title="info.navigation.support" />
      <div className="SupportInfo__list">
        <SupportItem support={emailBlock} />
        {isGlory && countryStatus && <SupportItem support={phoneBlock} />}
      </div>
    </div>
  );
};

export default SupportInfo;
